import { isNewYearDateExpire } from "../utils";
import Lantern from "./Lantern";
import Lanterns from "./Lanterns";

/**
 * @description 燈籠裝飾元件(單個+三個一組)
 * @returns {JSX.Element}
 */
const LanternsDecorations = () => {
  // 如果新年裝飾期間結束則不顯示燈籠
  if (isNewYearDateExpire()) return null;

  return (
    <>
      <Lanterns />
      <Lantern />
    </>
  );
};
export default LanternsDecorations;
